<!--<h1>Filter Editor:</h1><br /><br />-->
<!--<occupation-filter-editor [(ngModel)]="occupationDataSource"></occupation-filter-editor>
<br /><br /><br />
<occupation-filter-editor [(ngModel)]="occupationDataSource"></occupation-filter-editor>-->
<!--<industry-filter-editor [(ngModel)]="industryDataSource"></industry-filter-editor>
<br /><br /><br />
<industry-filter-editor [(ngModel)]="industryDataSource"></industry-filter-editor>-->

<!--<div class="row">
  <div class="col-md-6">
    <job-department-search [(ngModel)]="jobDepartmentSelectedValues"></job-department-search>
  </div>
  <div class="col-md-6">
    <job-department-search [(ngModel)]="jobDepartmentSelectedValues"></job-department-search>
  </div>
</div>-->

<!--<div class="row" style="height: 200px">
  <div class="col-md-6">
    <job-seniority-search [(ngModel)]="jobSenioritySelectedValues"></job-seniority-search>
  </div>
  <div class="col-md-6">
    <job-seniority-search [(ngModel)]="jobSenioritySelectedValues"></job-seniority-search>
  </div>
</div>-->

<!--<div class="row" style="height: 100%">
  <div class="col-md-6">
    <company-search [(ngModel)]="companySelectedValues"></company-search>
  </div>
  <div class="col-md-6">
    <company-search [(ngModel)]="companySelectedValues"></company-search>
  </div>
</div>-->
<button (click)="doSwitch()">Switch</button>
<div class="row" style="height: calc(100% - 50px)">
  <div class="col-md-6"><full-title-search name="titleOne" [(ngModel)]="titleValues"></full-title-search></div>
</div>
